
import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Fade,
  Avatar,
  Stack,
  InputAdornment,
  IconButton,
  Divider,
} from "@mui/material";







import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SecurityIcon from "@mui/icons-material/Security";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LoginIcon from "@mui/icons-material/Login";

import { MuiOtpInput } from "mui-one-time-password-input";
import { loginUser, verifyOtp } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import SEO from "../../utils/SEO";

import BouncingBallGame  from "../../utils/BouncingBallGame"


export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [step, setStep] = useState(1);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [userId, setUserId] = useState("");
  const [otp, setOtp] = useState("");

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // --------------------------------------------------
  // LOGIN
  // --------------------------------------------------

  const handleLogin = async () => {
    if (loading) return;

    if (!username.trim() || !password.trim()) {
      alert("Please enter Username and Password");
      return;
    }

    try {
      setLoading(true);

      const res = await loginUser({
        username: username.trim(),
        password,
      });

      setUserId(res.data.userId);
      setOtp("");
      setStep(2);

      alert("OTP sent to your registered email.");
    } catch (err) {
      alert(
        err.response?.data?.message ||
          "Login Failed"
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // VERIFY OTP
  // --------------------------------------------------

  const handleVerify = async (otpValue = otp) => {
    if (loading) return;

    if (!otpValue || otpValue.length !== 6) {
      return;
    }

    try {
      setLoading(true);

      const res = await verifyOtp({
        userId,
        otp: otpValue,
      });

      // Login ONLY after successful OTP verification
      login(
        res.data.user,
        res.data.token
      );

      navigate("/", {
        replace: true,
      });
    } catch (err) {
      // IMPORTANT:
      // Do not logout
      // Do not go back to step 1
      // Stay on OTP screen

      setOtp("");

      alert(
        err.response?.data?.message ||
          "Invalid OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // OTP CHANGE
  // --------------------------------------------------

  const handleOtpChange = (value) => {
    setOtp(value);

    if (value.length === 6) {
      handleVerify(value);
    }
  };

  // --------------------------------------------------
  // BACK TO LOGIN
  // --------------------------------------------------

  const handleBackToLogin = () => {
    if (loading) return;

    setOtp("");
    setUserId("");
    setStep(1);
  };

  return (
    <>
      <SEO
        title="WGR Data Management System"
        description="Mechanical Workshop, North Eastern Railway, Gorakhpur."
        url="https://wgr.mwsgkp.in/"
      />

      <Box
        sx={{
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          p: {
            xs: 2,
            sm: 3,
          },

          background:
            "linear-gradient(135deg, #eef6ff 0%, #f8fbff 45%, #eaf3ff 100%)",
        }}
      >
        {/* ---------------------------------------- */}
        {/* Decorative Background */}
        {/* ---------------------------------------- */}

        <Box
          sx={{
            position: "absolute",
            width: 420,
            height: 420,
            borderRadius: "50%",

            top: -180,
            right: -120,

            background:
              "linear-gradient(135deg, rgba(25,118,210,0.18), rgba(66,165,245,0.04))",

            filter: "blur(1px)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: 350,
            height: 350,
            borderRadius: "50%",

            bottom: -180,
            left: -130,

            background:
              "linear-gradient(135deg, rgba(25,118,210,0.12), rgba(66,165,245,0.03))",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: 180,
            height: 180,
            borderRadius: "50%",

            top: "20%",
            left: "8%",

            background:
              "rgba(66,165,245,0.06)",

            filter: "blur(2px)",
          }}
        />





<BouncingBallGame
  ballCount={18}
  minRadius={12}
  maxRadius={28}
  speed={2.2}
  mouseBreakRadius={25}
  clickBreakRadius={100}
/>






        {/* ---------------------------------------- */}
        {/* Login Card */}
        {/* ---------------------------------------- */}

        <Fade in timeout={700}>
          <Card
            elevation={0}
            sx={{
              width: "100%",
              maxWidth: 450,

              position: "relative",
              zIndex: 2,

              borderRadius: 4,

              border:
                "1px solid rgba(25,118,210,0.12)",

              background:
                "rgba(255,255,255,0.94)",

              backdropFilter: "blur(20px)",

              boxShadow:
                "0 25px 70px rgba(25,118,210,0.15)",

              overflow: "hidden",
            }}
          >
            {/* Top Accent */}
            <Box
              sx={{
                height: 5,

                background:
                  "linear-gradient(135deg, #1976d2, #42a5f5)",
              }}
            />

            <CardContent
              sx={{
                p: {
                  xs: 3,
                  sm: 5,
                },
              }}
            >
              {/* -------------------------------- */}
              {/* Header */}
              {/* -------------------------------- */}

              <Stack
                spacing={1.2}
                alignItems="center"
                mb={4}
              >
                <Avatar
                  sx={{
                    width: 76,
                    height: 76,

                    background:
                      "linear-gradient(135deg, #1976d2, #42a5f5)",

                    boxShadow:
                      "0 10px 25px rgba(25,118,210,0.28)",
                  }}
                >
                  {step === 1 ? (
                    <LockOutlinedIcon
                      sx={{ fontSize: 40 }}
                    />
                  ) : (
                    <SecurityIcon
                      sx={{ fontSize: 40 }}
                    />
                  )}
                </Avatar>

                <Typography
                  variant="h4"
                  fontWeight={700}
                  textAlign="center"
                  sx={{
                    color: "#17324d",
                    fontSize: {
                      xs: "1.7rem",
                      sm: "2rem",
                    },
                  }}
                >
                  {step === 1
                    ? "Secure Login"
                    : "Verify Your Identity"}
                </Typography>

                <Typography
                  color="text.secondary"
                  textAlign="center"
                  sx={{
                    fontSize: 14,
                  }}
                >
                  WGR Data Management System
                </Typography>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  textAlign="center"
                >
                  Mechanical Workshop, North Eastern Railway
                </Typography>
              </Stack>

              {/* -------------------------------- */}
              {/* LOGIN FORM */}
              {/* -------------------------------- */}

              {step === 1 && (
                <>
                  <TextField
                    fullWidth
                    autoFocus
                    label="Username"
                    value={username}
                    onChange={(e) =>
                      setUsername(e.target.value)
                    }
                    margin="normal"
                    disabled={loading}
                    autoComplete="username"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LoginIcon
                            color="primary"
                            sx={{ fontSize: 21 }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2.5,
                        backgroundColor: "#fbfdff",

                        "&:hover fieldset": {
                          borderColor:
                            "primary.main",
                        },

                        "&.Mui-focused fieldset": {
                          borderWidth: 2,
                        },
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleLogin();
                      }
                    }}
                  />

<TextField
  fullWidth
  type={showPassword ? "text" : "password"}
  label="Password"
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  margin="normal"
  disabled={loading}
  autoComplete="current-password"
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <LockOutlinedIcon
          color="primary"
          sx={{ fontSize: 21 }}
        />
      </InputAdornment>
    ),

    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          edge="end"
          disabled={loading}
          aria-label={
            showPassword
              ? "Hide password"
              : "Show password"
          }
          sx={{
            color: "primary.main",
            mr: 0.5,
          }}
        >
          {showPassword ? (
            <VisibilityOffIcon />
          ) : (
            <VisibilityIcon />
          )}
        </IconButton>
      </InputAdornment>
    ),
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: 2.5,
      backgroundColor: "#fbfdff",

      "&:hover fieldset": {
        borderColor: "primary.main",
      },

      "&.Mui-focused fieldset": {
        borderWidth: 2,
      },
    },
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  }}
/>



                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    disabled={loading}
                    onClick={handleLogin}
                    startIcon={
                      !loading ? (
                        <LoginIcon />
                      ) : null
                    }
                    sx={{
                      mt: 4,
                      height: 54,

                      borderRadius: 2.5,

                      textTransform: "none",

                      fontWeight: 700,
                      fontSize: 16,

                      background:
                        "linear-gradient(135deg, #1976d2, #42a5f5)",

                      boxShadow:
                        "0 8px 20px rgba(25,118,210,0.25)",

                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #1565c0, #2196f3)",

                        boxShadow:
                          "0 10px 25px rgba(25,118,210,0.32)",
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress
                        size={24}
                        color="inherit"
                      />
                    ) : (
                      "Continue to Secure Login"
                    )}
                  </Button>

                  <Divider
                    sx={{
                      mt: 4,
                      mb: 2,
                    }}
                  />

                  <Typography
                    variant="caption"
                    color="text.secondary"
                    textAlign="center"
                    display="block"
                  >
                    Your account is protected with
                    secure OTP verification.
                  </Typography>
                </>
              )}

              {/* -------------------------------- */}
              {/* OTP FORM */}
              {/* -------------------------------- */}

              {step === 2 && (
                <>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    mb={3}
                  >
                    <Box
                      sx={{
                        width: 52,
                        height: 52,
                        borderRadius: 2.5,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        background:
                          "linear-gradient(135deg, rgba(25,118,210,0.12), rgba(66,165,245,0.08))",

                        color: "primary.main",
                      }}
                    >
                      <EmailOutlinedIcon
                        sx={{ fontSize: 28 }}
                      />
                    </Box>

                    <Typography
                      variant="h6"
                      fontWeight={700}
                    >
                      Enter Verification Code
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                      sx={{
                        maxWidth: 330,
                        lineHeight: 1.6,
                      }}
                    >
                      A 6-digit OTP has been sent to
                      your registered email address.
                    </Typography>
                  </Stack>

                
<MuiOtpInput
  value={otp}
  onChange={(value) => {
    // Allow digits only
    const numericValue = value.replace(/\D/g, "").slice(0, 6);
    handleOtpChange(numericValue);
  }}
  length={6}
  autoFocus
  TextFieldsProps={{
    disabled: loading,
    type: "tel",
    inputProps: {
      inputMode: "numeric",
      pattern: "[0-9]*",
      autoComplete: "one-time-code",
      enterKeyHint: "done",
    },
  
sx: {
  "& .MuiOutlinedInput-root": {
    borderRadius: { xs: 1.5, sm: 2 },
    backgroundColor: "#fbfdff",
    height: { xs: 44, sm: 54 },

    "& fieldset": {
      borderColor: "rgba(25,118,210,0.25)",
    },

    "&:hover fieldset": {
      borderColor: "primary.main",
    },

    "&.Mui-focused fieldset": {
      borderWidth: 2,
    },
  },

  "& input": {
    fontWeight: 700,
    fontSize: { xs: 17, sm: 22 },
    textAlign: "center",
    padding: { xs: "8px 0", sm: "12px 0" },
  },

  // Reduce gaps between OTP boxes on mobile
  "& .MuiBox-root": {
    gap: { xs: "5px", sm: "10px" },
  },
},

    onKeyDown: (e) => {
      if (e.key === "Enter" && otp.length === 6) {
        handleVerify();
      }
    },
  }}
/>


                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    disabled={
                      loading ||
                      otp.length !== 6
                    }
                    onClick={() => handleVerify()}
                    startIcon={
                      !loading ? (
                        <SecurityIcon />
                      ) : null
                    }
                    sx={{
                      mt: 4,
                      height: 54,

                      borderRadius: 2.5,

                      textTransform: "none",

                      fontWeight: 700,
                      fontSize: 16,

                      background:
                        "linear-gradient(135deg, #1976d2, #42a5f5)",

                      boxShadow:
                        "0 8px 20px rgba(25,118,210,0.25)",

                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #1565c0, #2196f3)",
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress
                        size={24}
                        color="inherit"
                      />
                    ) : (
                      "Verify & Continue"
                    )}
                  </Button>

                  <Button
                    fullWidth
                    disabled={loading}
                    onClick={handleBackToLogin}
                    sx={{
                      mt: 1.5,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Back to Login
                  </Button>

                  <Divider
                    sx={{
                      mt: 3,
                      mb: 2,
                    }}
                  />

                  <Typography
                    variant="caption"
                    color="text.secondary"
                    textAlign="center"
                    display="block"
                  >
                    Never share your OTP with anyone.
                  </Typography>
                </>
              )}
            </CardContent>
          </Card>
        </Fade>
      </Box>
    </>
  );
}

